<template>
  <ModalDefault modal_id="notificationModal"
                header="y"
                class_header="border-bottom-0"
                class_footer="border-top-0"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_803')"
                footer="s"
                icon="">
    <div class="px-2 py-2 pb-3" slot="body">
      <div class="row ">
        <div class="col-12 pt-3 pb-0 text-center title-color">
          <div style="display: flex;
                      justify-content: center;">
            <div class="icon-circle" :class="`bg-${notifications.notification.data.color}-soft`">
              <i class="bx"
                 :class="`${notifications.notification.data.icon} text-${notifications.notification.data.color}`"
                 style="font-size: 30px;"></i>
            </div>
          </div>
          <h5 class="pt-3">{{ notifications.notification.data.title }}</h5>
        </div>
        <div class="pt-0 pb-3 px-3 col-12 text-center">
          {{ notifications.notification.data.text }}
        </div>
        <div v-if="notifications.notification.data.url && notifications.notification.data.icon !== 'bx-task'" class="col-12 pt-1 text-center">
          <a :href="notifications.notification.data.url" target="_blank" class="btn btn-sm btn-outline-primary rounded-0 px-3">
            <i class="bx bx-download pr-2"></i>
            <span>{{ getTranslations('expression_190') }}</span>
          </a>
        </div>
        <div v-if="notifications.notification.data.url && notifications.notification.data.icon === 'bx-task'" class="col-12 pt-1 text-center">
          <router-link :to="{ name: 'Tasks' }" :href="notifications.notification.data.url" data-dismiss="modal" class="btn btn-sm btn-outline-primary rounded-0 px-3">
            <i class="bx bx-show pr-2"></i>
            <span>{{ getTranslations('expression_804') }}</span>
          </router-link>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-1 row justify-content-between">
      <div :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-12 text-center' : ''">
        <small>
          <i class="bx bx-time pl-2 pr-2"></i>{{ notifications.notification.created }}
        </small>
      </div>
      <div :class="($mq === 'mobile' || $mq === 'tablet') ? 'col-12' : ''" :style="($mq === 'mobile' || $mq === 'tablet') ? 'justify-content: center;' : ''" class="d-flex">
          <div class="pr-2">
            <div @click.prevent="deleteNotification" class="btn-sm rounded-0 btn-outline-danger cursor_pointer">
              <i class="bx bx-trash-alt mr-1"></i> {{ getTranslations('expression_696') }}
            </div>
          </div>
          <div>
            <div v-if="notifications.notification.status_key === 0" @click="setStatus" class="btn-sm rounded-0 btn-outline-primary cursor_pointer">
              <i class="bx bx-check-double mr-1"></i> {{ getTranslations('expression_805') }}
            </div>
            <div v-else @click="setStatus" class="btn-sm rounded-0 btn-outline-secondary cursor_pointer">
              <i class="bx bx-check mr-1"></i> {{ getTranslations('expression_806') }}
            </div>
          </div>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalNotification",
  components: {
    ModalDefault
  },
  computed: {
    ...mapState(['notifications', 'configs']),
    ...mapGetters([])
  },
  methods: {
    setStatus() {
      if(this.notifications.notification.status_key === 0) {
        this.$store.dispatch('updateNotification', {
          id: this.notifications.notification.id,
          status_key: 1
        })
        this.notifications.notification.status_key = 1
      } else {
        this.$store.dispatch('updateNotification', {
          id: this.notifications.notification.id,
          status_key: 0
        })
        this.notifications.notification.status_key = 0
      }
    },
    deleteNotification() {
      this.$swal.fire({
        title: this.getTranslations('expression_902'),
        text: this.getTranslations('expression_311'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: this.getTranslations('expression_421'),
        cancelButtonText: this.getTranslations('expression_355')
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store.dispatch("deleteNotification", this.notifications.notification)
        }
      })
    },
  }
}
</script>

<style scoped>

.bg-primary-soft {
  background-color: #dae7fb !important;
}
.text-primary {
   color: #0061f2 !important;
 }
.icon-circle {
  height: 4rem;
  width: 4rem;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bg-primary-soft {
  background-color: #dae7fb !important;
}
.bg-secondary-soft {
  background-color: #d7d7d7 !important;
}
.bg-info-soft {
  background-color: #daf8fb !important;
}
.bg-warning-soft {
  background-color: #fbebda !important;
}
.bg-danger-soft {
  background-color: #fbdada !important;
}
.bg-success-soft {
  background-color: #dafbdb !important;
}
</style>
